import { render, staticRenderFns } from "./EditGoodByUser.vue?vue&type=template&id=386b83ea&"
import script from "./EditGoodByUser.vue?vue&type=script&lang=js&"
export * from "./EditGoodByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports